<template>
  <form-group class="ma-0 pa-0">
    <client-photos-card
      v-model="payload"
    >
      <v-row>
        <client-document-images
          v-model="clientFiles"
          :loading="loading"
        />
      </v-row>
    </client-photos-card>
    <company-photos-card>
      <client-document-images
        v-model="companyFiles"
        :loading="loading"
      />
    </company-photos-card>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import ClientPhotosCard from 'Modules/contacard/analysisTable/components/cards/ClientPhotosCard.vue';
import AnalysisUserPhotosMixin from 'Modules/contacard/analysisTable/components/displays/AnalysisUserPhotosMixin';
import ClientDocumentImages from '../columns/ClientDocumentImages.vue';
import CompanyPhotosCard from '../cards/CompanyPhotosCard.vue';

export default {
  name: 'AnalysisPhotosInfoDisplay',
  components: {
    FormGroup, ClientPhotosCard, ClientDocumentImages, CompanyPhotosCard,
  },
  mixins: [AnalysisUserPhotosMixin],
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    payload() {
      return this.value;
    },
  },
};
</script>
